import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss'
import Calendar from '../../../component/Inc/Calendar';
import PopRequestPoint from '../_PopRequestPoint';

function Salary() {
  const [modalOpen, setModalOpen] = useState(false);
  // const [modalPolicyOpen, setModalPolicyOpen] = useState(false);
  return (
    <main className="com_container com_salary">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_7'>교사수업 명세서 <span className="bar"/><span className="point_txt">최교사103ㆍ수학ㆍ시수 : 25,000</span></h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">인센티브 지급</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className='com_board_list__top'>
              <select className="select">
                <option value="이지수능 (본사)">이지수능 (본사)</option>
              </select>
            </div>
            <Calendar type="salary" />
            <hr className="com_divider" />
            <div className="salary_wrap">
              {/* 급여 명세서 */}
              <div className="receipt">
                <div className="detail_tit dot">
                  3월 급여 명세서
                </div>
                  <table className='com_board_list'>
                    <colgroup>
                      <col width="50%"/><col width="20%"/><col width="30%"/>
                    </colgroup>
                    <thead>
                      <tr>
                        <th>+ 수수료 명</th>  
                        <th>회차</th>  
                        <th>금액</th>  
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>지도관리 수수료</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>원고료</th>
                        <td>12회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>장기 특별 수수료</th>
                        <td>12회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>특별 수수료</th>
                        <td>4회</td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>우수관리 수수료</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>원거리 수수료</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>지목 수수료</th>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <th>
                          <div className='input_receipt'>
                            <button className="btn_delete"></button>
                            <input type="text" className="input" placeholder="입력" />
                            <input type="text" className="input" placeholder="입력" />
                          </div>
                        </th>
                        <td></td>
                        <td>
                          <input type="text" className="input" placeholder="입력" />
                        </td>
                      </tr>
                      <tr>
                        <th>총 인센티브 지급액</th>
                        <td></td>
                        <td className='td_point bold'>898,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn gray xs">+ 목록 추가</button>
                  </div>

                  {/* 공제 수수료 */}
                  <div className="detail_tit sub">* 공제 수수료</div>
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="50%"/>
                    </colgroup>
                    <thead>
                      <tr>
                        <th>- 수수료 명</th>
                        <th>금액</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>사업소득세</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>사업주민세</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>상조회비</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>보증보험료</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>선급금외</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>고용보험</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>산재보험</th>
                        <td></td>
                      </tr>
                      <tr>
                        <th>
                          <div className='input_receipt'>
                            <button className="btn_delete"></button>
                            <input type="text" className="input" placeholder="입력" />
                            <input type="text" className="input" placeholder="입력" />
                          </div>
                        </th>
                        <td>
                          <input type="text" className="input" placeholder="입력" />
                        </td>
                      </tr>
                      <tr>
                        <th>총 수수료 액</th>
                        <td className='td_point bold'>898,000</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="com_btn_wrap right">
                    <button className="com_btn gray xs">+ 목록 추가</button>
                  </div>
                  {/* 총 지급액 */}
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="50%"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="bold">급여 총 지급액</th>
                        <td className='td_point bold bg_gray'>898,000</td>
                      </tr>
                    </tbody>
                  </table>
                <div className="com_btn_wrap center">
                  <button className="com_btn orange xs">월급 지급하기</button>
                </div>
              </div>
              
              {/* 수업진행 상세내역 */}
              <div className="detail">
                <div className="detail_tit dot">2월 수업 진행 상세 내역
                </div>
                <table className='com_board_list'>
                  <thead>
                    <tr>
                      <th>학생명</th>
                      <th>회차</th>
                      <th>기수</th>
                      <th>수업시간</th>
                      <th>지도관리<br/>수수료</th>
                      <th>원고료</th>
                      <th>장기특별<br/>수수료</th>
                      <th>특별<br/>수수료</th>
                      <th>우수관리</th>
                      <th>원거리</th>
                      <th>지목</th>
                      <th>정산금액<br/>전달</th>
                      <th>합계</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowSpan={2}>홍학생123</td>
                      <td>5회</td>
                      <td>
                        <button className="btn_link">2기</button>
                      </td>
                      <td>60분</td>
                      <td>5,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>홍교사103<br/>5,000</td>
                      <td>78,000</td>
                    </tr>
                    <tr>
                      <td>5회</td>
                      <td>
                        <button className="btn_link">2기</button>
                      </td>
                      <td>60분</td>
                      <td>5,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>25,000</td>
                      <td>홍교사103<br/>5,000</td>
                      <td>78,000</td>
                    </tr>
                    {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                      return (
                        <tr key={idx}>
                          <td></td>
                          <td>5회</td>
                          <td>
                            <button className="btn_link">2기</button>
                          </td>
                          <td>60분</td>
                          <td>5,000</td>
                          <td>25,000</td>
                          <td>25,000</td>
                          <td>25,000</td>
                          <td>25,000</td>
                          <td>25,000</td>
                          <td>25,000</td>
                          <td>홍교사103<br/>5,000</td>
                          <td>78,000</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                <div className="com_btn_wrap right">
                  <button className="com_btn black xs btn_print">인쇄하기</button>
                  <button className="com_btn black xs btn_down_orange">다운로드</button>
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default Salary;
